import React, { Fragment, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faTimesCircle,
  faTrash,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import axios from "axios";
import Draggable from "react-draggable"; // Both at the same time

const App = () => {
  const [isPaneOpen, setOpen] = useState(false);
  const [cartId, setCartId] = useState(null);
  const [items, setItems] = useState([]);
  const [itemAmount, setItemAmount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("EUR");
  const [loading, setLoading] = useState(true);
  const [loc, setLoc] = useState(window.location.href);

  useEffect(() => {
    if (
      sessionStorage.getItem("cart_id") !== null &&
      sessionStorage.getItem("cart_id") !== undefined
    ) {
      setCartId(sessionStorage.getItem("cart_id"));
    }
  }, [isPaneOpen]);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoc(window.location.href);
      if (
        sessionStorage.getItem("cart_qty") !== null &&
        sessionStorage.getItem("cart_qty") !== undefined
      ) {
        setItemAmount(sessionStorage.getItem("cart_qty"));
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const reloadCart = () => {
    axios
      .get(
        window.gurado_js_ajax.urls.proxy + "?endpoint=/getCart&cartId=" + cartId
      )
      .then((response) => {
        let data = JSON.parse(response.data);
        if (data.items !== null && data.items !== undefined) {
          setItems(data.items);
          setItemAmount(data.items.length);
          sessionStorage.setItem("cart_qty", data.items.length);
          setCurrencyCode(data.currency_code);
          setTotalPrice(data.grand_total);
        } else {
          setItems([]);
          setItemAmount(0);
          sessionStorage.setItem("cart_qty", 0);
          setCurrencyCode("EUR");
          setTotalPrice(0);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    if (cartId === null) return;
    console.log(cartId);
    reloadCart();
  }, [cartId, isPaneOpen]);

  const deleteItem = async (item_id) => {
    setLoading(true);
    console.log(item_id);
    if (cartId === null) return;
    let req = await axios
      .get(
        window.gurado_js_ajax.urls.proxy +
          "?endpoint=/deleteItem&cartId=" +
          cartId +
          "&item_id=" +
          item_id
      )
      .catch((err) => {
        console.log(err);
      });
    if (
      sessionStorage.getItem("cart_qty") !== null &&
      sessionStorage.getItem("cart_qty") !== undefined &&
      parseFloat(sessionStorage.getItem("cart_qty")) > 0
    ) {
      let new_qty = parseFloat(sessionStorage.getItem("cart_qty")) - 1;
      sessionStorage.setItem("cart_qty", new_qty);
    }
    reloadCart();
  };

  if (parseFloat(itemAmount) === 0) {
    return <></>;
  }
  if (loc.endsWith("#/checkout")) {
    return <></>;
  }

  return (
    <Fragment>
      <Draggable>
        <div
          className="styledicon"
          style={{ cursor: "pointer", zIndex: "20" }}
          onClick={() => {
            console.log("lel");
            setOpen(true);
          }}
          onTouchStart={() => {
            console.log("lel");
            setOpen(true);
          }}
          onTouchMove={() => {
            setOpen(false);
          }}
        >
          <svg
            width="30"
            height="30"
            fill="currentColor"
            className="bi bi-cart2"
            viewBox="0 0 16 16"
          >
            <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"></path>
          </svg>
          <div className="styledamount" style={{ position: "absolute" }}>
            <span className="amount-text">{itemAmount}</span>
          </div>
        </div>
      </Draggable>
      <SlidingPane
        className="guradopanel"
        isOpen={isPaneOpen}
        hideHeader={true}
        onRequestClose={() => setOpen(false)}
      >
        {!loading ? (
          <div style={{ padding: "20px" }}>
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(false)}
            />
            <div
              className="g-pane-container"
              style={{
                maxHeight: "calc(100% - 200px)",
                width: "100%",
                overflowY: "auto",
              }}
            >
              {items.map((item) => {
                return (
                  <div key={item.item_id} style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "50%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img src={item.voucher_design_template.thumbnail_url} />
                    </div>
                    <div style={{ width: "50%" }}>
                      <div style={{ width: "100%" }}>
                        <div style={{ width: "100%", paddingLeft: "20px" }}>
                          <b>{item.name}</b>
                        </div>
                      </div>
                      <div style={{ width: "100%", paddingLeft: "20px" }}>
                        <div>
                          {item.unit_price.toFixed(2).replace(".", ",")}€
                        </div>
                        {/* <Col>
                      <input
                        type="number"
                        style={{ width: "60px", fontSize: "10pt" }}
                        defaultValue={item.qty}
                      />
                    </Col> */}
                        <div style={{ width: "100%" }}>
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{ color: "red", cursor: "pointer" }}
                            onClick={() => deleteItem(item.item_id)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                position: "fixed",
                bottom: "0",
                height: "200px",
                width: "calc(100% - 64px)",
                paddingTop: "50px",
              }}
            >
              <div className="pricetag">
                {totalPrice.toFixed(2)} {currencyCode}
              </div>
              <a href={sessionStorage.getItem("cart_url")}>
                <button
                  onClick={() => setOpen(false)}
                  style={{
                    fontSize: "15pt",
                    width: "100%",
                    height: "60px",
                    borderRadius: "30px",
                  }}
                >
                  Zur Kasse
                </button>
              </a>
            </div>
          </div>
        ) : (
          <span>Loading</span>
        )}
      </SlidingPane>
    </Fragment>
  );
};

export default App;
